import {z} from 'zod';
import {tm} from '../i18n';

const urlSchema = z.string().url({message: tm('validation.invalidUrl')});

export function validateURL(url: string): {isValid: boolean; error: string} {
    const result = urlSchema.safeParse(url);
    return {
        isValid: result.success,
        error: result.success ? '' : result.error.issues[0]?.message,
    };
}
